//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Shuffle",
  props: {
    tag: {
      type: String
    },
    enforceWidth : {
      type: Boolean,
      default: false
    }
  },
  methods: {
    before(el) {
      if (!this.enforceWidth) return;
      const width = this.$el.firstElementChild.offsetWidth;
      el.style.width = `${width}px`;
    },
    after(el) {
      if (!this.enforceWidth) return;
      el.style.width = ''
    } 
  }
};
